import {Component, HostBinding} from '@angular/core';
import {DialogBaseComponent} from '~shared/ng/components/dialog/base/dialog.base.component';
import {DialogType} from '~shared/types/dialog.types';

@Component({
    standalone: true,
    template: '',
})
export abstract class ModalBaseComponent<O = {}, R = any> extends DialogBaseComponent<O, R> {
    @HostBinding('attr.class')
    public readonly hostAttrClass = 'modal fade';
    public readonly type = DialogType.MODAL;
}
